<template>
  <el-main class="container">
    <Nav>
      <div class="left" slot="left">
        <span>优惠券名称</span>
      </div>
      <div class="right" slot="right">
        <el-button type="primary" @click="network().getParkCouponExcel()">导出Excel</el-button>
      </div>
    </Nav>
    <div class="select-date">
      <span>选择日期</span>
      <el-date-picker
        v-model="date"
        type="daterange"
        @change="event().selectDate($event)"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
    </div>
    <table-pagination
      ref="table"
      class="table"
      :config="config"
      :datasource="datasource"
      :idRow="false"
      @change-page="handlerPageChange">
    </table-pagination>
  </el-main>
</template>

<script>
import Nav from '@/components/nav'
import TablePagination from '@/components/table-pagination'
import { getParkDetails, getParkCouponExcel } from '@/api/park'
import utils from '@/jslib/utils'
import { ExchangeDate } from '@/jslib/utils'
export default {
  data() {
    return {
      body: {
        pageSize: 10,
        pageIndex: 1,
        startTime: '',
        endTime: '',
        uuid: '',
        word: ''
      },
      excelBody: {
        startTime: '',
        endTime: '',
        uuid: ''
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'createTime',
            label: '发送时间'
          },
          {
            prop: 'title',
            label: '停车券名称'
          },
          {
            prop: 'type',
            label: '停车券类型',
            type: 'status',
            rule: [
              {
                value: 0,
                label: '折扣券'
              },
              {
                value: 1,
                label: '面值券'
              }
            ]
          },
          {
            prop: 'date',
            label: '有效时间'
          },
          {
            prop: 'industryName',
            label: '所属产业'
          },
          {
            prop: 'enterpriseName',
            label: '企业名称'
          },
          {
            prop: 'number',
            label: '发送数量'
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      },
      date: ''
    }
  },
  created() {
    if(this.$route.query.id){
      this.body.uuid = JSON.parse(this.$route.query.id)
    }
    this.network().getParkDetails()
  },
  methods: {
    event() {
      return {
        search: () => {
          this.network().getParkDetails()
        },
        selectDate: (e) => {
          if (e == null) {
            this.body.endTime = ''
            this.body.startTime = ''
          } else {
            this.body.startTime = ExchangeDate(this.date[0])
            this.body.endTime = ExchangeDate(this.date[1])
          }
          this.network().getParkDetails()
        }
      }
    },
    network() {
      return {
        getParkDetails: async() => {
          const { data } = await getParkDetails(this.body)
          data.list.forEach((item, index) => {
            item.date = item.startDate + '~' + item.endDate
          })
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        getParkCouponExcel: async() => {
          this.excelBody.startTime = this.body.startTime
          this.excelBody.endTime = this.body.endTime
          this.excelBody.uuid = this.body.uuid
          const { data } = await getParkCouponExcel()
          utils.exportExcel(data, '导出停车券发送记录excel')
        }
      }
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getParkDetails()
    }
  },
  components: {
    Nav,
    TablePagination
  }
}
</script>

<style scoped lang="scss">
.left{
  span{
    font-weight: bold;
    cursor: pointer;
  }
}
.select-date{
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    span{
      margin-right: 15px;
    }
  }
</style>
